import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    props: true,
    meta: {
      title: 'Эрхэм зорилго "Тикийн эсрэг Ноофен"',
      description:
        "Хүүхдэд тикийг даван туулж, өсөж том болоход нь туслаарай",
    },
  },
  {
    path: "/article1",
    name: "article1",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/Article1View.vue"),
    props: true,
    meta: {
      title: "Тикийн саад бэрхшээл",
      description:
        "Өсөж том болох гэдэг сансрын нисгэгч болохтой адил юм. Дасан зохицох, даван туулах, мянга мянган ур чадварыг сурах явц. Тик нь хэт их ачааллын үр дагавар бөгөөд үүнийг арилгах шаардлагатай.",
    },
  },
  {
    path: "/video",
    name: "video",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/VideoView.vue"),
    props: true,
    meta: {
      title: "Ноофен нислэгийн өмнөх товч заавар",
      description:
        "Тикийн эмчилгээний эхний шатанд юу хийх, хэрхэн эмчилгээ бичиж өгөх, ямар үр дүнд хүрч болох талаар олж мэдээрэй.",
    },
  },
  {
    path: "/article2",
    name: "article2",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/Article2View.vue"),
    props: true,
    meta: {
      title: "Тикийн татах хүч",
      description:
        "Эхний үзүүлэлтүүдтэй танилцаж, тикийн татах хүчийг даван туулах эмчилгээг эхлүүлээрэй. Та эхлэхэд бүрэн бэлэн байна!",
    },
  },
  {
    path: "/quiz",
    name: "quiz",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/QuizView.vue"),
    props: true,
    meta: {
      title: "Нислэгийн өмнөх шалгах хуудас",
      description:
        "Та эмнэлзүйн практикт тикийг эмчлэхэд бэлэн байгаа ч мэдлэгээ бататгаж, богино асуулт хариултаар өөрийгөө сориорой!",
    },
  },
  {
    path: "/material",
    name: "material",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/MaterialView.vue"),
    props: true,
    meta: {
      title: "Эцэг эхчүүдэд зориулсан санамж",
      description:
        "Тикийн эмчилгээний амжилт нь зөвхөн танаас төдийгүй, эцэг эх нь хүүхдийнхээ амьдралыг зөв замд чиглүүлж чадах эсэхээс хамаарна. Энэ санамжийг тэдэнтэй хуваалцаарай.",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => {
    return { x: 0, y: 0 };
  },
});

export default router;
